const INITIAL_STATE = {
  prices: [
    { name: "UNOCOIN", value: 0 },
    { name: "ZebPay", value: 0 },
    { name: "WazirX", value: 0 },
    { name: "CoinDcx", value: 0 },
  ],
};

const rootReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "UNOCOIN": {
      let index = state.prices.findIndex(
        (item) => item.name.toLowerCase() === action.type.toLowerCase()
      );
      let prices = [...state.prices];
      prices[index] = { ...prices[index], value: action.payload };
      return { ...state, prices };
    }
    case "ZEBPAY": {
      let index = state.prices.findIndex(
        (item) => item.name.toLowerCase() === action.type.toLowerCase()
      );
      let prices = [...state.prices];
      prices[index] = { ...prices[index], value: action.payload };
      return { ...state, prices };
    }
    case "WAZIRX": {
      let index = state.prices.findIndex(
        (item) => item.name.toLowerCase() === action.type.toLowerCase()
      );
      let prices = [...state.prices];
      prices[index] = { ...prices[index], value: action.payload };
      return { ...state, prices };
    }
    case "COINDCX": {
      let index = state.prices.findIndex(
        (item) => item.name.toLowerCase() === action.type.toLowerCase()
      );
      let prices = [...state.prices];
      prices[index] = { ...prices[index], value: action.payload };
      return { ...state, prices };
    }
    case "POCKETBITS": {
      let index = state.prices.findIndex(
        (item) => item.name.toLowerCase() === action.type.toLowerCase()
      );
      let prices = [...state.prices];
      prices[index] = { ...prices[index], value: action.payload };
      return { ...state, prices };
    }
    default:
      return state;
  }
};

export default rootReducer;
